<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-content v-if="canShow">
        <v-layout id="action-btns">
            <DocumentFullScreenAdminMenu :document="currentDocument"/>

            <v-dialog v-model="tagForm" width="500">
                <template v-slot:activator="{ on }">
                    <v-btn v-if="isCurrentUserAdmin" fab v-on="on">
                        <v-icon color="green">assistant</v-icon>
                    </v-btn>
                </template>

                <DocumentTagForm v-if="tagForm" :document="currentDocument" @tag-form-close="tagForm = false"/>
            </v-dialog>

            <v-btn fab class="green lighten-2" :href="mediaSrc" target="_blank">
                <v-icon color="white">get_app</v-icon>
            </v-btn>

            <v-btn fab class="red lighten-2" @click="close">
                <v-icon color="white">close</v-icon>
            </v-btn>
        </v-layout>

        <v-layout id="media-container">
            <v-img v-if="canShowImage" v-touch="{left: next, right: previous}" :src="mediaSrc" contain/>
            <video v-else-if="canShowVideo" controls>
                <source :src="mediaSrc" :type="mediaType">
                <p>Votre navigateur ne prend pas en charge les vidéos HTML5.</p>
            </video>
            <v-icon id="prev-media" color="white" size="5rem" @click="previous">chevron_left</v-icon>
            <v-icon id="next-media" color="white" size="5rem" @click="next">chevron_right</v-icon>
        </v-layout>
    </v-content>
</template>

<script>
    import {mapGetters} from "vuex";
    import {DOCUMENT_SHOW} from "../../store/actions.type";
    import DocumentFullScreenAdminMenu from "./DocumentFullScreenAdminMenu";
    import DocumentTagForm from "../form/DocumentTagForm";
    import {DocumentService} from "../../services/document.service";

    export default {
        name: "MediaFullScreen",
        components: {DocumentTagForm, DocumentFullScreenAdminMenu},
        data: () => ({
            tagForm: false
        }),
        computed: {
            ...mapGetters(["currentDocument", "isCurrentUserAdmin", "medias"]),
            mediaSrc: function () {
                return this.canShow ? (process.env.VUE_APP_API_BASE_URL + this.currentDocument.path) : null;
            },
            canShow: function () {
                return DocumentService.isMedia(this.currentDocument);
            },
            canShowImage: function () {
                return DocumentService.isImage(this.currentDocument);
            },
            canShowVideo: function () {
                return DocumentService.isVideo(this.currentDocument);
            },
            mediaType: function () {
                return 'video/' + this.DocumentService.getDocumentExt(this.currentDocument);
            }
        },
        mounted() {
            document.addEventListener("keyup", (event) => {
                if (this.canShow) {
                    switch (event.key) {
                    case 'ArrowRight':
                        this.next();
                        break;

                    case 'ArrowLeft':
                        this.previous();
                        break;
                    }
                }
            });
        },
        methods: {
            /**
             * Ferme l'affichage du fullscreen
             */
            close: function () {
                this.$store.dispatch(DOCUMENT_SHOW, null);
            },

            /**
             * Récupère l'index du média courrant dans la liste du store
             */
            getCurrentMediaIndex: function () {
                if (this.canShow) {
                    for (let index in this.medias) {
                        if (this.medias[index].slug === this.currentDocument.slug) {
                            return parseInt(index);
                        }
                    }
                }

                return null;
            },

            /**
             * Navigation vers le média suivant
             */
            next: function () {
                let currentIndex = this.getCurrentMediaIndex();
                let nextMedia = (this.medias[currentIndex + 1] === undefined) ? this.medias[0] : this.medias[currentIndex + 1];
                this.$store.dispatch(DOCUMENT_SHOW, nextMedia.slug);
            },

            /**
             * Navigation vers le média précédent
             */
            previous: function () {
                let currentIndex = this.getCurrentMediaIndex();
                let previousMedia = (currentIndex === 0) ? this.medias[this.medias.length - 1] : this.medias[currentIndex - 1];
                this.$store.dispatch(DOCUMENT_SHOW, previousMedia.slug);
            },
        }
    };
</script>

<style scoped lang="scss">
    #media-container {
        position: fixed;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.7);
        padding: 2%;
        height: 100%;
        width: 100%;
        z-index: 15;
    }

    #action-btns {
        position: fixed;
        top: 2%;
        right: 2%;
        z-index: 20;
    }

    #prev-media, #next-media {
        position: absolute;
        top: calc(50% - 2.5rem);
    }

    #prev-media {
        left: 0;
    }

    #next-media {
        right: 0;
    }

    video {
        margin: auto;
        object-fit: contain;
    }
</style>
